module.exports = __webpack_public_path__ + "img/icon-web-home-01.cf4f19ae.png";